import { FC } from 'react';
import { styled } from '@mui/material';

interface IError {
  message: string;
}

export interface IErrorProps {
  error: IError | string;
}

const ErrorWrapper = styled('div')`
  color: rgb(211, 47, 47);
  min-height: 300px;
  display: flex;
  padding: 16px;
  text-align: center;
  justify-content: center;
  width: 100%;
  align-items: center;
  font-size: 20px;
`;

export const TableError: FC<IErrorProps> = ({ error }) => {
  const message = typeof error === 'string' ? error : error.message;
  return <ErrorWrapper>{message}</ErrorWrapper>;
};
